import { Component } from 'react'

interface ErrorBoundaryProps {
  id: string
  metadata?: {
    url?: string
  }
}

export class ErrorBoundary extends Component<ErrorBoundaryProps> {
  componentDidCatch(error) {
    console.error(`Uncaught error on ${this.props.id}:`, error)
    console.error(`Error metadata`, this.props.metadata)
  }

  render() {
    return this.props.children
  }
}
